module.exports = __webpack_public_path__ + "img/record-icon.d0289dc0.png";